<template>
  <div :class="margin" class="row pb-3 border-bottom product-col">
    <div class="col-12 px-0 d-flex align-items-center">
      <div class="col">
        <p class="mb-2">
          <span class="text-secondary font-weight-bold">
            <i v-if="icon" :class="icon" class="text-primary mr-2"></i>
            <inertia-link v-if="item.link_product_id && productRoute" :href="route(productRoute, item.link_product_id)">{{sku}}</inertia-link> <span v-else>{{sku}}</span> -&nbsp;
          </span>
          {{ itemName || item.product_name }} {{ item.variation_option_product_name }}
          <p v-if="item.product_included">({{ item.product_included.product_name }} x {{ item.product_included.qty }})</p>

        </p>
      </div>
      <slot name="headerContent"></slot>
    </div>
    <div v-if="imgUrl || item.image_url" :class="[productStyle === 'compact' ? 'col-4 justify-content-center' : 'col-6 justify-content-start']" class="col-lg-2 d-flex align-items-start">
      <img v-if="imgUrl || item.image_url" class="product-image cursor-pointer" :class="productStyle" :src="imgUrl || item.image_url" @click.stop="e => toggleOverlay(e, item.id)" />

      <OverlayPanel v-if="imgUrl || item.image_url" :ref="`product-row-image-overlay${item.id}`" :showCloseIcon="true" :dismissable="true">
        <img :src="imgUrl || item.image_url" />
      </OverlayPanel>
    </div>
    <div class="col col-lg-10">
      <div class="d-flex justify-content-between align-items-start align-items-lg-end flex-column flex-lg-row">
        <div class="slot-container">
          <slot></slot>
        </div>

        <div class="mt-3 mt-lg-0">
          <slot name="priceInfo"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import OverlayPanel from 'primevue/overlaypanel'

  export default {
    components: {
      OverlayPanel
    },
    props: {
      item: Object,
      sku: String,
      icon: String,
      imgUrl: String,
      productStyle: String,
      itemName: String,
      productRoute: String,
      margin: {
        type: String,
        default: 'mb-3'
      }
    },
    methods: {
      toggleOverlay(event, id) {
        this.$refs[`product-row-image-overlay${id}`].toggle(event)
      },
    }
  }
</script>

<style scoped>
  .product-image {
    max-width: 100%;
    object-fit: cover;
    max-height: 120px;
  }

  .product-image.compact {
    max-height: 70px;
  }

  .product-image.inline {
    max-height: 40px;
  }

  .slot-container {
    flex: 1;
  }

  @media (min-width: 992px) {
    .product-image {
      max-height: 75px;
    }
  }
</style>